export const getCurrentHost = (): string => {
  const { location: { hostname = '' } = {} } = window || global || {}

  return hostname
}
